import React, { ReactNode } from 'react';
import { IMaskInput } from 'react-imask';

import { Field } from 'common/components/form/Input';
import { getNumber } from 'common/components/form/Number/helpers';
import { INumberField } from 'common/components/form/Number/NumberField';
import { useFormikField } from 'common/components/form/useFormikField';
import { FieldWrapper } from 'common/components/form/Wrapper';
import { InputRightSide, InputWrapperLabel } from 'common/components/form/Wrapper/Wrapper.styled';

export interface ICurrencyField extends Omit<INumberField, 'scale'> {
  annex?: string | number;
  type?: 'prefix' | 'suffix';
  tooltip?: ReactNode;
  rightSideSymbol?: ReactNode;
  placeholder?: string;
  margin?: string;
  width?: string;
  numberOfDecimals?: number | undefined;
}

const getMask = (annex?: string | number, annexType?: 'prefix' | 'suffix') => {
  if (!annex) {
    return 'num';
  }

  return annexType === 'prefix' ? `${annex} num` : `num ${annex}`;
};

export const NumberMaskField = ({
  name,
  label,
  annex,
  annexType = 'suffix',
  disabled,
  tooltip,
  rightSideSymbol,
  placeholder,
  margin,
  width,
  numberOfDecimals,
  ...rest
}: ICurrencyField) => {
  const { error, hasError, setValue } = useFormikField(name);
  const currencyMask = getMask(annex, annexType);

  const { customValue } = rest;

  return (
    <FieldWrapper
      name={name}
      label={label}
      isRequired={rest.isRequired}
      isDisabled={disabled}
      error={hasError ? `${error}` : undefined}
      tooltip={tooltip}
      margin={margin}
      width={width}
    >
      <InputWrapperLabel $hasError={hasError} $isDisabled={disabled}>
        <Field type="text" name={name} disabled={disabled}>
          {({ field }: any) => {
            return (
              <>
                <IMaskInput
                  {...rest}
                  lazy={false}
                  mask={currencyMask}
                  placeholder={placeholder}
                  blocks={{
                    prefix: {
                      mask: '',
                    },
                    num: {
                      mask: Number,
                      scale: numberOfDecimals ?? 2,
                      thousandsSeparator: ' ',
                      padFractionalZeros: true,
                      radix: ',',
                      mapToRadix: ['.', ','],
                      placeholderChar: '_',
                      min: rest.min,
                      max: rest.max,
                    },
                    suffix: {
                      mask: '',
                    },
                  }}
                  value={customValue?.toString() ?? field?.value?.toString()}
                  onAccept={(value, mask) => {
                    if (!mask.unmaskedValue) {
                      setValue(value);

                      return;
                    }
                    const number = getNumber(mask.unmaskedValue);

                    // dozvoli upis negativnog broja, ako započne sa minusom
                    setValue(Object.is(number, -0) ? mask.unmaskedValue : number);
                  }}
                  unmask={true}
                />
                <InputRightSide>{rightSideSymbol}</InputRightSide>
              </>
            );
          }}
        </Field>
      </InputWrapperLabel>
    </FieldWrapper>
  );
};
